<div id=login-frame-container>
  <div id=login-frame>
    <h1>{{'login' | translate}}</h1>
    <button hidden class="button-facebook" (click)="loginFacebook()">FACEBOOK</button>
    <button class="button-google" (click)="loginGoogle()">GOOGLE</button>
  </div>
</div>
